import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/nav.css";
import "./styles/screens.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createApiClient } from "./api/client.js";
import { App } from "./app/App.js";
import { ServicesProvider } from "./app/services.js";
import { SessionStore } from "./app/session.js";
import { signOut } from "./app/signOut.js";
import { readConfig } from "./config.js";
import { startAnalytics } from "./lib/analytics.js";
import { browserStore } from "./lib/storage.js";
import { ToastProvider } from "./ui/index.js";

const rootElement = document.getElementById("root");
if (rootElement === null) throw new Error("index.html has no #root element");

const config = readConfig(import.meta.env);
if (config.analytics) startAnalytics(window);
const store = browserStore();
const sessions = new SessionStore(store);
const api = createApiClient({
  baseUrl: config.apiBaseUrl,
  fetch: (input, init) => window.fetch(input, init),
  getToken: sessions.token,
  onUnauthorized: () => { signOut(sessions); },
  newIdempotencyKey: () => crypto.randomUUID(),
});

createRoot(rootElement).render(
  <StrictMode>
    <ServicesProvider services={{ api, sessions, store }}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ServicesProvider>
  </StrictMode>,
);
